import { render, staticRenderFns } from "./GenderSelectInput.vue?vue&type=template&id=784faf2f&"
import script from "./GenderSelectInput.vue?vue&type=script&lang=js&"
export * from "./GenderSelectInput.vue?vue&type=script&lang=js&"
import style0 from "./GenderSelectInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports